import * as React from 'react';
import { __ } from 'react-i18n';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';
import styled from 'styled-components';
import { rem } from 'polished';
import { TitleWithChildren } from '../General/TitleWithChildren';
import { ContactInfo } from './Form/ContactInfo';
import { BillingAddress } from './Form/BillingAddress';
import { DeliveryAddress } from './Form/DeliveryAddress';
import { FormTextArea } from '../Form/FormTextArea';
import OptionChooser from './OptionChooser/OptionChooser';
import { BlockWithTitle } from '../General/BlockWithTitle';
import { Select } from '../General/Select';
import { TextP } from '../../Defaults/Text';
import { ZemplinLoaderWrapper } from '../../..';
import { remapDeliveryItem, remapPaymentItem } from './utilities';
import { prop, arrayToObject } from '../../../utilities';
import { InfoText, InfoType } from '../General/InfoText';

interface Props {
  data: any;
  isFetching: boolean;
  isFetchingDelAndPayInfo: boolean;
  updateCart: any;
  delAndPayInfoIds: string[];
  delAndPayInfoById: any;
  b2cAllowedPayments: string[];
  isB2B: boolean;
}

function CartDeliveryPart({
  data,
  isFetching,
  delAndPayInfoIds,
  delAndPayInfoById,
  isFetchingDelAndPayInfo,
  updateCart,
  b2cAllowedPayments,
  isB2B,
}: Props) {
  const deliveryId = prop(data, 'delivery.id');
  const paymentId = prop(data, 'payment.id');

  if (isFetchingDelAndPayInfo) {
    return <ZemplinLoaderWrapper />;
  }
  if (!delAndPayInfoById || Object.keys(delAndPayInfoById).length === 0) {
    return (
      <InfoText
        type={InfoType.ERROR}
        info={__('Nenašiel sa žiadny spôsob dopravy, kontaktuje nás prosím.')}
      />
    );
  }

  const onChangeDelivery = id => {
    updateCart({ ...data, delivery: { id } });
  };

  const onChangePayment = id => {
    updateCart({ ...data, payment: { id } });
  };

  const deliveryItems = Object.keys(delAndPayInfoById).map(key =>
    remapDeliveryItem(delAndPayInfoById[key]),
  );

  const currentDeliveryOption = delAndPayInfoById[deliveryId];

  const paymentsById =
    currentDeliveryOption && currentDeliveryOption.payments
      ? arrayToObject(currentDeliveryOption.payments, 'payment_id')
      : [];
  const paymentItems =
    currentDeliveryOption &&
    currentDeliveryOption.payments &&
    currentDeliveryOption.payments.map(payment => remapPaymentItem(payment));
  const b2cPaymentItems = paymentItems
    ? paymentItems.filter(a => b2cAllowedPayments.includes(a.id))
    : null;
  const correctPaymentItems = isB2B ? paymentItems : b2cPaymentItems;

  const selectedDelivery = deliveryId
    ? remapDeliveryItem(delAndPayInfoById[deliveryId])
    : null;
  const selectedPayment = paymentId
    ? remapPaymentItem(paymentsById[paymentId])
    : null;

  return (
    <Wrapper>
      <TitleWithChildren title={__('Spôsob dopravy')}>
        <OptionChooser
          items={deliveryItems}
          selectedOption={selectedDelivery}
          handleOptionClick={onChangeDelivery}
        />
      </TitleWithChildren>
      {/* ZATIAL VYPNUTE KYM NIE JE JASNA FUNKCNOST*/}
      {/* <BlockWithTitle title={__('Dátum dodania')}>
        <DeliveryInfoWrapper>
          <Text>
            {__(
              'Zvoľte dátum kedy chcete tovar doručiť a spravíme všetko preto aby vám bol doručený vo vami vybranom dátume.',
            )}
          </Text>
          <Select
            marginBottom={0}
            mobileMarginBottom={0}
            name="dateOfDelivery"
            label={''}
            value={''}
            options={[{ value: 'sk', name: 'Slovensko' }]}
            // tslint:disable-next-line:jsx-no-lambda
            onChange={onChange}
          />
        </DeliveryInfoWrapper>
      </BlockWithTitle> */}
      <TitleWithChildren title={__('Spôsob platby')}>
        {correctPaymentItems && correctPaymentItems.length > 0 ? (
          <OptionChooser
            items={correctPaymentItems}
            selectedOption={selectedPayment}
            handleOptionClick={onChangePayment}
          />
        ) : (
          <InfoText
            type={InfoType.INFO}
            info={__('Zvoľte prosím preferovaný spôsob dopravy')}
            noIcon={true}
          />
        )}
      </TitleWithChildren>
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  max-width: ${rem(688)};
  width: 100%;
`;

const Text = styled(TextP)`
  margin-bottom: ${rem(24)};
  font-size: ${rem(14)};
`;

const DeliveryInfoWrapper = styled(FlexCol)`
  padding: ${rem(32)};
`;

export { CartDeliveryPart };
